import Landing from "../../Landing";

export default () => (
  <Landing
    content={{
      title: "DIRA",
      subtitle: "Digital Interview Reflective Activity",
      text: `
The Interview with a Designer/Design Practice is designed to broaden your understanding of design practice by interviewing someone from “the industry”. Seeking out the breadth of design practice in bespoke, small to medium and large organisations, alliances, centres and agencies is the focus of this task. Part of the process is to prepare content to cover in the interview, and to communicate effectively and professionally with a potential designer.

The second part is to reflect on the interview process. DIRA provides an online environment in which to have these conversations which allows a peer to provide feedback on your reflective ideas and process. These are then stored and create an archive that can be reviewed at any time.

What a user needs:

- a desktop computer, laptop or tablet
- a stable internet connection
- a working webcam and microphone
- a well-lit and quiet workspace
- head / ear phones preferred
- Chrome / Safari browser preferred
      `,
      logo: { src: "dira.png" },
    }}
    disabled
  />
);
